<script>

import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';
import config from '../../common/genericPanelConf';

import CommonService from '../../services/common';

import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import Button from 'primevue/button';
import Editor from 'primevue/editor';
import Calendar from 'primevue/calendar';
import Fieldset from 'primevue/fieldset';
import { required, maxLength, minValue, maxValue  } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

import GenericCustomAutocompleteV2 from '../../components/generic/GenericCustomAutocompleteV2.vue'
import GenericBooleanDropdown from '../../components/generic/GenericBooleanDropdown.vue'
import GenericCustomMultiSelectGrid from './GenericCustomMultiSelectGrid.vue';
import GenericCustomMasterDataMultiSelect from './GenericCustomMasterDataMultiSelect.vue';
import GenericDataTable from './GenericDataTable.vue';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';


export default{
    props: ['configuration', 'category', 'name', 'id'],
    setup: () => ({ v$: useVuelidate() }),
    components: { GenericDataTable, GenericCustomMultiSelectGrid, Editor, InputText, Button, GenericCustomAutocompleteV2, GenericBooleanDropdown, Calendar, InputNumber, Fieldset, GenericCustomMasterDataMultiSelect, TabView, TabPanel },
    data(){
        return {
            fieldsets: [],
            submitted: false,
            fields: [],
            disabled: false,
            data: {},
            fieldsTypes: {},
            dataTableConfigurations: {}
        }
    },
    validations(){
        let validations = {
            data: {}
        }

        if(this.configuration.columns){
            for(let i=0; i<this.configuration.columns.length; i++){
                if(!this.configuration.columns[i].formHide){
                    let v = this.configuration.columns[i].validations;
                    validations.data[this.configuration.columns[i].name] = {}
                    if(v){
                        if(v.maxLength){
                            validations.data[this.configuration.columns[i].name].maxLength = maxLength(v.maxLength);
                        }
                        
                        if(v.required){
                            validations.data[this.configuration.columns[i].name] = { ...validations.data[this.configuration.columns[i].name], required }
                        }

                        if(v.minValue){
                            validations.data[this.configuration.columns[i].name].maxLength = minValue(v.minValue);
                        }

                        if(v.maxValue){
                            validations.data[this.configuration.columns[i].name].maxLength = maxValue(v.maxValue);
                        }
                    }

                }
            }
        }
        return validations;
    },
    created(){
        if(this.configuration){
            this.generateFields();
            this.loadItem();
            if(this.configuration.dataTables && this.configuration.dataTables.length > 0){
                for(let i=0; i<this.configuration.dataTables.length; i++){
                    let dt = this.configuration.dataTables[i];
                    this.dataTableConfigurations[dt.dataTableUnderForm] = {
                        ...config.getConfiguration(dt.dataTableUnderForm), 
                        hideRefresh: true
                    }
                    this.dataTableConfigurations[dt.dataTableUnderForm].columns.find(c => c.name == dt.dataTableDefaultKey).defaultFilterValue = this.id

                    this.dataTableConfigurations[dt.dataTableUnderForm].columns.find(c => c.name == dt.dataTableDefaultKey).defaultFilter = true
                }
            }
            
        }
    },
    methods: {
        generateFields(){

            this.fieldsets = {};
            if(this.configuration.fieldsets){
                for(var key in this.configuration.fieldsets){
                    this.fieldsets[key] = this.configuration.fieldsets[key];
                    this.fieldsets[key].columns = [];
                }
            }else{
                this.fieldsets.general = {
                    label: 'general',
                    columns: []
                }
            }

            this.fields = [];
            for(let i=0; i<this.configuration.columns.length; i++){
                if(!this.configuration.columns[i].formHide){
                    this.fields.push(this.configuration.columns[i]);
                    this.fieldsTypes[this.configuration.columns[i].name] = this.configuration.columns[i].type;

                    let fieldsetName = this.configuration.columns[i].fieldset ?? 'general';
                    this.fieldsets[fieldsetName].columns.push(this.configuration.columns[i]);
                }
            }

        },
        goBack(){
            let uri = `/${this.category}/${this.name}`;
            this.$router.push(uri);
        },
        loadItem(){
            if(this.id && this.id != '0'){

                if(this.configuration.getItemWithList){
                    let f = {
                        filter: JSON.stringify([{
                            operator: 'eq',
                            value: this.id,
                            property: 'Id'
                        }])
                    };
                    CommonService.loadGeneric(this.configuration.api, f, response => {
                        if(response.success){
                            let item = response.data[0];
                            for(var key in item){
                                if(this.fieldsTypes[key] == 'date' && item[key]){
                                    item[key] = Utils.dateToCurrentTimeZone(item[key]);
                                }
                            }
                            this.data = item;
                        }
                    })
                }else{

                    CommonService.loadGenericItem(this.configuration.api,this.id, response => {
                        if(response.success){
                            for(var key in response.data){
                                if(this.fieldsTypes[key] == 'date' && response.data[key]){
                                    response.data[key] = Utils.dateToCurrentTimeZone(response.data[key]);
                                }
                            }
                            this.data = response.data;
                        }
                    });
                }

            }else{
                if(this.$route.query){
                    for (var [key, value] of Object.entries(this.$route.query)) {
                        this.data[key] = parseInt(value);
                    }
                }
            }
        },
        saveItem(valid){
            this.submitted = true;

            if (!valid){
                return;
            }
            this.$store.dispatch("generic/setLoading", true);

            this.disabled = true;

            if(this.configuration.updateWithPost){
                // SAVE
                CommonService.createItem(this.configuration.api, this.data, response => {
                    this.disabled = false;
                    this.$store.dispatch("generic/setLoading", false);
                    if(response.success){

                        // let uri = `/${this.category}/${this.name}/${response.data[this.configuration.idColumn]}`;

                        if(this.configuration.enableUpdate){
                            this.$router.push(
                                { 
                                    name: 'generic-details',
                                    params: {
                                        category: this.category,
                                        name: this.name,
                                        id: response.data[this.configuration.idColumn],
                                        successMessage: true
                                    } 
                                }
                            )
                        }else{
                            this.goBack()
                        }
                        // this.$router.push(uri);
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                })
            }else if(this.data.id){
                // UPDATE
                CommonService.updateItem(this.configuration.api, this.data, response => {
                    this.disabled = false;
                    this.$store.dispatch("generic/setLoading", false);
                    if(response.success){
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                }, this.configuration.idColumn)
            }else{
                // SAVE
                CommonService.createItem(this.configuration.api, this.data, response => {
                    this.disabled = false;
                    this.$store.dispatch("generic/setLoading", false);
                    if(response.success){

                        // let uri = `/${this.category}/${this.name}/${response.data[this.configuration.idColumn]}`;

                        if(this.configuration.enableUpdate){
                            this.$router.push(
                                { 
                                    name: 'generic-details',
                                    params: {
                                        category: this.category,
                                        name: this.name,
                                        id: response.data[this.configuration.idColumn],
                                        successMessage: true
                                    } 
                                }
                            )
                        }else{
                            this.goBack()
                        }
                        // this.$router.push(uri);
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                })
            }
        }
    },
    computed: {
        constants(){
            return CommonConstants;
        }
    }
}

</script>

<style lang="css" scoped>
</style>


<template>
    <div>
        <Button :label="$t('btn.back')" icon="pi pi-arrow-left" class="p-button-info mr-2" @click="goBack" v-if="configuration && !configuration.disableBack" />
        <Button :label="$t('btn.save')" icon="pi pi-save" class="p-button-success mr-2" @click="saveItem(!v$.$invalid)" v-if="configuration && !configuration.disableSave"/>
        <span v-if="configuration && configuration.formCustomActions">
            <Button 
            v-show="(customAction.onlyUpdate && data[configuration.idColumn]) || !customAction.onlyUpdate"
            v-for="customAction in configuration.formCustomActions" :key="customAction.name"
            :label="$t(customAction.title)" :icon="customAction.icon" class="mr-2" @click="customAction.action(data, this)" />
        </span>
        <div style="height:20px"></div>

        <div class="grid">
            <div class="col-12">
                <div class="card">
                    <Fieldset v-for="(fieldset, key) in fieldsets" :key="key" :legend="$t(fieldset.label)">
                    <div class="grid formgrid" >
                        <div :class="{'col-12 field': true, 'lg:col-3': field.type != 'editor' && field.type != 'multi-select-grid'}" v-for="field in fieldset.columns" :key="field.name">
                            <span>
                                <label :for="field.name" :class="{'p-error':v$.data[field.name].$invalid && submitted}">{{$t(field.label)}}</label>
                                <GenericBooleanDropdown
                                    :id="field.name" 
                                    v-if="field.type == 'boolean'"
                                    v-model="data[field.name]" 
                                    :disabled="disabled || field.readOnly"
                                    :class="{'p-invalid':v$.data[field.name].$invalid && submitted, 'w-full': true}"
                                />
                                <InputText 
                                    :id="field.name" type="text" 
                                    v-if="field.type == 'string'" 
                                    v-model="data[field.name]" 
                                    :disabled="disabled || field.readOnly || (field.disabledInEdit && id != 0)"
                                    :class="{'p-invalid':v$.data[field.name].$invalid && submitted, 'w-full': true}" />
                                <InputNumber 
                                    :id="field.name" 
                                    v-if="field.type == 'number'"
                                    v-model="data[field.name]"
                                    :disabled="disabled || field.readOnly || (field.disabledInEdit && id != 0)" 
                                    :class="{'p-invalid':v$.data[field.name].$invalid && submitted, 'w-full': true}" /> 
                                <InputNumber 
                                    :id="field.name" 
                                    v-if="field.type == 'decimal'"
                                    mode="decimal" :maxFractionDigits="field.digits" :max="field.max"
                                    v-model="data[field.name]"
                                    :disabled="disabled || field.readOnly || (field.disabledInEdit && id != 0)" 
                                    :class="{'p-invalid':v$.data[field.name].$invalid && submitted, 'w-full': true}" /> 
                                <Calendar 
                                    :id="field.name" 
                                    v-if="field.type == 'date'" 
                                    v-model="data[field.name]" 
                                    :disabled="disabled || field.readOnly || (field.disabledInEdit && id != 0)" 
                                    :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                                    :dateFormat="field.format ?? constants.DATE_FORMAT"
                                    :class="{'p-invalid':v$.data[field.name].$invalid && submitted, 'w-full': true}" />
                                <GenericCustomAutocompleteV2 
                                    :field="field"
                                    v-model="data[field.name]" 
                                    :disabled="disabled || field.readOnly || (field.disabledInEdit && id != 0)" 
                                    :api="field.selectApi"
                                    :staticOptions="field.staticOptions"
                                    :sortField="field.sortField ?? null"
                                    v-if="field.type == 'select'" 
                                    :format="field.selectFormat"
                                    :class="{'p-invalid':v$.data[field.name].$invalid && submitted, 'w-full': true}" />
                                <GenericCustomMasterDataMultiSelect 
                                    :field="field"
                                    :name="field.name"
                                    :class="{'p-invalid':v$.data[field.name].$invalid && submitted, 'w-full': true}"
                                    v-model="data[field.name]" 
                                    :disabled="disabled || field.readOnly || (field.disabledInEdit && id != 0)" 
                                    :api="typeof field.selectApi === 'function' ? field.selectApi(this.$route.query) : field.selectApi"
                                    v-if="field.type == 'multi-select'"
                                    :staticOptions="field.gridFilterArray"
                                    :disableStore="field.gridFilterDisableStore" 
                                    :localized="field.localized"
                                    :format="field.selectFormat" />
                                <GenericCustomMultiSelectGrid
                                    :field="field"
                                    :name="field.name"
                                    :class="{'p-invalid':v$.data[field.name].$invalid && submitted, 'w-full': true}"
                                    v-model="data[field.name]" 
                                    :disabled="disabled || field.readOnly || (field.disabledInEdit && id != 0)" 
                                    :api="typeof field.selectApi === 'function' ? field.selectApi(this.$route.query) : field.selectApi"
                                    v-if="field.type == 'multi-select-grid'"
                                    :staticOptions="field.gridFilterArray"
                                    :disableStore="field.gridFilterDisableStore" 
                                    :localized="field.localized"
                                    />
                                <Editor 
                                    :id="field.name" 
                                    :class="{'p-invalid':v$.data[field.name].$invalid && submitted, 'w-full': true}"
                                    v-if="field.type == 'editor'"
                                    :disabled="disabled || field.readOnly || (field.disabledInEdit && id != 0)" 
                                    editorStyle="height: 320px" 
                                    v-model="data[field.name]" />
                            </span>
                            <div v-if="field.type != 'boolean' && ((v$.data[field.name].$invalid && submitted) || v$.data[field.name].$pending.$response)">
                                <small class="p-error" v-for="error in v$.data[field.name].$silentErrors" :key="error.$validator">
                                    {{error.$message}}
                                </small>
                            </div>
                        </div>
                    </div>
                    </Fieldset>
                </div>
            </div>
            <div class="col-12" v-if="configuration.dataTables && configuration.dataTables.length > 0">
                <TabView>
                    <TabPanel :header="$t(dt.label)"  v-for="dt in configuration.dataTables" :key="dt.dataTableUnderForm + '_' + id">
                        <GenericDataTable  :configuration="dataTableConfigurations[dt.dataTableUnderForm]" :category="category" :name="dt.dataTableUnderForm" :defaultId="id" :ref="dt.dataTableUnderForm + '_' + id"/>
                    </TabPanel>
                </TabView>
            </div>
        </div>
    </div>
</template>